<section class="home-section request-appointment">
  <div class="container container-lg">
    <div class="row">
      <div class="col-12 request-appointment__header">
        <div class="image-wrapper">
          <img *ngIf="brand.networkId == networks.GEO" src="./assets/images/img-home.png">
          <img *ngIf="brand.networkId == networks.WTG" src="./assets/images/bg-appointment.jpg">
        </div>
        <div class="content-wrapper home-section__title">
          <h6>Richiedi appuntamento</h6>
          <span class="request-appointment__subtitle">Richiedi un appuntamento con un nostro consulente.</span>
          <button *ngIf="currentStep !== 3" class="custom-button btn" (click)="toggleForm($event)"
                  [ngClass]="{'btn--blue-outline' : isFormOpened, 'btn--brand-color-03' : !isFormOpened}" >
            {{ isFormOpened ? 'Annulla' : 'Scegli una data'}}
          </button>

          <div class="calendar-appointments" *ngIf="isFormOpened">
            <app-element-loader
              [loadingStatus]="loadingStatus"
              [loadingMessage]="loadingMessage"
            >
            </app-element-loader>
            <form [hidden]="currentStep!==1" (ngSubmit)="goToNextStep()" name="request-appointment" #requestForm="ngForm">
              <ngb-datepicker name="selectedDate" required
                              [(ngModel)]="selectedDate"
              ></ngb-datepicker>
              <div class="form-row row">
                <div class="form-group form-group-custom col-4">
                  <ngb-timepicker name="selectedTime" required
                                  [(ngModel)]="selectedTime"
                  ></ngb-timepicker>
                </div>
                <div class="form-group form-group-custom col-8 pt-1">
                  <label for="TypeSelect" class="form-group-custom__label">Metodo di contatto</label>
                  <select [(ngModel)]="selectedType" class="form-control form-control-custom" id="TypeSelect"
                          name="selectedType" required>
                    <option [value]="undefined">Seleziona metodo...</option>
                    <option [value]="appointmentTypes.AGENCY">In Agenzia</option>
                    <option [value]="appointmentTypes.SKYPE">Skype</option>
                    <option [value]="appointmentTypes.WHATSAPP">Whatsapp</option>
                    <option [value]="appointmentTypes.EMAIL">Email</option>
                    <option [value]="appointmentTypes.TEL">Telefono</option>
                  </select>
                </div>
              </div>
              <div class="text-center">
                <button [disabled]="requestForm.invalid" class="custom-button btn btn--brand-color-03">Prosegui</button>
              </div>
            </form>
            <form [hidden]="currentStep!==2" (ngSubmit)="sendRequest()" name="send-appointment" #sendForm="ngForm">
              <div class="form-row row">
                <div class="form-group form-group-custom col">
                  <input placeholder="Nome e Cognome..." class="form-control" type="text" name="name" [(ngModel)]="name" required>
                </div>
              </div>
              <div class="form-row row" *ngIf="selectedType === appointmentTypes.AGENCY || selectedType === appointmentTypes.WHATSAPP || selectedType === appointmentTypes.TEL">
                <div class="form-group form-group-custom col">
                  <input placeholder="Numero di telefono..." class="form-control" type="number" name="telephone" [(ngModel)]="telephone" required>
                </div>
              </div>
              <div class="form-row row">
                <div class="form-group form-group-custom col" *ngIf="selectedType === appointmentTypes.SKYPE || selectedType === appointmentTypes.EMAIL ||  selectedType === appointmentTypes.AGENCY">
                  <input placeholder="Email..." class="form-control" type="text" name="email" [(ngModel)]="email" email required>
                </div>
              </div>
              <div class="form-row row">
                <div class="form-group form-group-custom col">
                  <textarea placeholder="Richiesta..." class="form-control" rows="8" name="note" [(ngModel)]="note" required></textarea>
                </div>
              </div>
              <div class="form-row row" *ngIf="hasMultipleStores">
                <div class="form-group form-group-custom col">
                  <div class="agency-selector">
                    <div class="agency-selector__label">Agenzia di riferimento:</div>
                    <div class="agency-selector__info"
                         *ngIf="selectedStore">
                      {{ selectedStore.denomination }} - {{ selectedStore.city }}{{(selectedStore.province) ? (' (' + selectedStore.province + ')') : ''}}<br>
                      (<span class="agency-selector__change" (click)="openStoreLocatorModal()">cambia</span>)
                    </div>
                    <button class="custom-button btn btn--brand-color-03"
                            type="button"
                            *ngIf="!selectedStore"
                            (click)="openStoreLocatorModal()">
                      Seleziona agenzia
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group-custom">
                <label for="privacyCheckbox" class="form-check-custom">
                  <input required ngModel type="checkbox" name="privacyCheckbox" id="privacyCheckbox">
                  <span>Dichiaro di aver letto e compreso <a (click)="openPrivacy($event)">l’informativa privacy.</a></span>
                  <span class="form-check-custom__check"></span>
                </label>
              </div>
              <div class="text-center">
                <button [disabled]="sendForm.invalid || !selectedStore" class="custom-button btn btn--brand-color-03">
                  Richiedi Appuntamento
                </button>
              </div>
            </form>
            <div [hidden]="currentStep!==3">
              <div class="alert" [ngClass]="messageClass">{{message}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
